import React from 'react';
import { Box, Chip, Divider, Grid, Typography } from '@mui/material';
import { COLORS } from '@/constants';

interface PriceTiersDisplayProps {
  priceTiers: Array<{ minUnits: number; maxUnits?: number | null; pricePerUnit: number }>;
  minPricePerClient: number;
  formatCurrency: (value: number) => string;
}

/**
 * Faixas de preço por unidade (condomínio) — apenas plano Condomínio. Extraído de
 * UnifiedPricingCalculator.tsx (F7).
 */
export const PriceTiersDisplay: React.FC<PriceTiersDisplayProps> = ({
  priceTiers,
  minPricePerClient,
  formatCurrency,
}) => {
  if (priceTiers.length === 0) return null;

  return (
    <Grid item xs={12}>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ mt: 2, p: 3, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #e0e0e0' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2, color: 'text.primary' }}>
          Preço por unidade (condomínio)
        </Typography>
        {minPricePerClient > 0 && (
          <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'text.secondary' }}>
            * Valor mínimo por condomínio: {formatCurrency(minPricePerClient)}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
          {[...priceTiers]
            .sort((a, b) => a.minUnits - b.minUnits)
            .map((tier, index) => {
              const maxUnitsStr = tier.maxUnits ? `-${tier.maxUnits}` : '+';
              return (
                <Chip
                  key={`tier-${index}`}
                  label={`${tier.minUnits}${maxUnitsStr} unidades: ${formatCurrency(tier.pricePerUnit)}/unidade`}
                  size="small"
                  variant="outlined"
                  sx={{
                    borderColor: COLORS.primary,
                    color: COLORS.primary,
                    '&:hover': {
                      bgcolor: '#e3f2fd',
                      borderColor: '#1565c0',
                    },
                  }}
                />
              );
            })}
        </Box>
      </Box>
    </Grid>
  );
};

export default PriceTiersDisplay;
